export default __webpack_public_path__ + "static/media/easter-hero-left.7632a687.svg";